import React, { useRef, useEffect } from 'react';
import {
  StyledTextArea,
  StyledTextAreaContainer,
  StyledTextLabel,
} from './styled.textArea';
import { ITextInput } from '../../../@types/textInput';
import { Body5 } from './../../typography';
import { ErrorValidation } from './../ErrorValidation';
import { useTranslation } from 'react-i18next';

export function TextArea ({
  onValueChange,
  textValue,
  title,
  placeholder,
  disabled,
  isError,
  maxLength,
}: ITextInput) {
  const { t } = useTranslation();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'inherit';
      const newHeight = `${textareaRef.current.scrollHeight}px`;
      textareaRef.current.style.height = newHeight;
    }
  }, [textValue]);

  return (
    <StyledTextAreaContainer>
      {title && (
        <StyledTextLabel>
          <Body5 color="eerieBlack">{title}</Body5>
        </StyledTextLabel>
      )}
      <StyledTextArea
        onChange={onChange}
        ref={textareaRef}
        value={textValue}
        placeholder={placeholder}
        disabled={disabled}
        isError={isError}
        maxLength={maxLength}
      />
      {isError && (
        <ErrorValidation
          message={t('COMMON.MY_AUDIT.ASSIGN_FORM.PLEASE_FILL_VALID_DETAILS')}
        />
      )}
    </StyledTextAreaContainer>
  );
}
